module.exports = __webpack_public_path__ + "static/media/Home.f301f6fe.md";